import gql from "graphql-tag";
import { graphql } from "react-apollo";

import { shipmentsByIds } from "~/graphql/types";

export interface IResponseProps {
  shipmentsQuery: shipmentsByIds;
}

export interface IInputProps {
  shipmentIds: string[];
}

export const SHIPMENT_EVENT_FRAGMENT = gql`
  fragment ShipmentEventFragment on ShipmentEvent {
    status
    description
    createdAt
  }
`;

export const SHIPMENT_COUNTRY_FRAGMENT = gql`
  fragment ShipmentCountryFragment on ShipmentCountry {
    name
    companyName
    companyUrl
  }
`;

export const SHIPMENTS_QUERY = gql`
  query shipmentsByIds($ids: [String!]!) {
    shipments: shipmentsByIds(ids: $ids) {
      id
      status
      statusDescription
      shippingTime

      originCountry {
        ...ShipmentCountryFragment
      }

      destinationCountry {
        ...ShipmentCountryFragment
      }

      events {
        ...ShipmentEventFragment
      }
    }
  }

  ${SHIPMENT_COUNTRY_FRAGMENT}
  ${SHIPMENT_EVENT_FRAGMENT}
`;

export const withShipments = graphql<IInputProps>(SHIPMENTS_QUERY, {
  name: "shipmentsQuery",
  options({ shipmentIds }) {
    return {
      variables: {
        ids: shipmentIds
      }
    };
  }
});

export {
  shipmentsByIds,
  ShipmentStatus,
  shipmentsByIds_shipments as IShipment,
  shipmentsByIds_shipments_destinationCountry as IShipmentCountry,
  shipmentsByIds_shipments_events as IShipmentEvent,
  shipmentsByIdsVariables
} from "~/graphql/types";



// WEBPACK FOOTER //
// ./src/graphql/queries/shipment/shipmentsByIds.ts